import { Label, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@recipes/ui';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useHouseholds } from './hooks';

const PERSONAL = '__personal__';

/** "Personal / <household>" selector used by collections, shopping lists, meal plan, pantry. */
export function HouseholdSelect({
  value,
  onChange,
  label,
  includePersonal = true,
  className,
}: {
  value: string | null;
  onChange: (householdId: string | null) => void;
  label?: string;
  includePersonal?: boolean;
  className?: string;
}) {
  const { t } = useTranslation();
  const id = useId();
  const { data: households } = useHouseholds();
  if (!households || households.length === 0) return null;
  return (
    <div className={className}>
      <Label htmlFor={id}>{label ?? t('shared.household.label')}</Label>
      <Select value={value ?? PERSONAL} onValueChange={(v) => onChange(v === PERSONAL ? null : v)}>
        <SelectTrigger id={id} className="mt-1">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {includePersonal && (
            <SelectItem value={PERSONAL}>{t('shared.household.personal')}</SelectItem>
          )}
          {households.map((h) => (
            <SelectItem key={h.id} value={h.id}>
              {h.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
